import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class TenantDetailsRemoverService {

    constructor(private http: AdalHttp) {
    }

    deleteTenantEntry(tenantName: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/tenants/${tenantName}`;
        return this.http.delete(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/tenant-details-remover/tenant-details-remover.service.ts
 **/